import { useShortcutsStore, useShortcutsActionsStore } from './context.tsx';

export const useShortcuts = () => useShortcutsStore();

export const useShortcutsActions = () => {
	const [, actions] = useShortcutsActionsStore();

	return [undefined, actions] as const;
};
